import { useMemo } from 'react';
import { useAccessToken } from '../auth/use-access-token';
import { AdminService } from '../services/admin';

export function useAdminService() {
  const getAccessTokenSilently = useAccessToken();

  return useMemo(() => new AdminService(getAccessTokenSilently), [getAccessTokenSilently]);
}
